<ng-template
  let-extraClass="extraClass"
  #topNav>
  @if (!isRightSideContent) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Mark Registered'"
      [canGoBack]="true"
      [noBow]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <form [formGroup]="form">
    <tidy-wrapper [class]="isRightSideContent ? 'right-side-scroll-enabled' : ''">
      @if (taxName) {
        <tidy-row>
          <tidy-text
            [body]="taxName"
            [translate]="false" />
        </tidy-row>
      }
      <tidy-row>
        <tidy-text
          [helper]="'Enter the license or tax account number the agency gave you when you registered.'" />
      </tidy-row>
      <tidy-card>
        <tidy-row class="field-bottom-padding">
          <tidy-input
            formControlName="license_number"
            [form]="form.controls.license_number"
            [label]="'License Number'"
            [icon]="'assets/svg/receipt-outline.svg'"
            [submitted]="submitted"
            [errorMessage]="'Please enter the license number.'" />
        </tidy-row>
      </tidy-card>

      @if (errorMessage) {
        <tidy-error-message [text]="errorMessage" />
      }

      <tidy-button
        [text]="'Mark Registered'"
        [action]="boundSave"
        [disabled]="saving"
        class="primary" />
    </tidy-wrapper>
  </form>
</ng-template>

@if (!isRightSideContent) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (isRightSideContent) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
